import React, { useState } from 'react'

import { Button } from '@material-ui/core'

import { ConfirmationDialog } from 'components'
// Import direto (e não pelo barrel de components) para não fechar um ciclo:
// o barrel também exporta este componente.
import RiskAssumedDialog from '../RiskAssumedDialog'

import useSnackbar from 'hooks/useSnackbar'

import constants from 'constants/index'
import helpers from 'helpers'

// Ações do rodapé do parecer: reabrir o projeto e assumir o risco. O service vem
// por prop, então app e portal de convidados compartilham os dois fluxos e seus
// diálogos.
const PrivacyByDesignReviewActions = ({
  privacyByDesign,
  service,
  refresh = () => {},
  onReopen = () => {},
}) => {
  const [openReopenDialog, setOpenReopenDialog] = useState(false)
  const [openRiskAssumedDialog, setOpenRiskAssumedDialog] = useState(false)

  const snackbar = useSnackbar()

  const {
    APPROVED_STATUS_LABEL,
    CONFIRMATION_CHANGE_STATUS_TEXTS,
    PENDING_STATUS_LABEL,
    REOPEN_ACTION_BUTTON_STATUS,
    RISK_ASSUMED_STATUS_LABEL,
  } = constants.privacyByDesign

  // Risco só pode ser assumido em projeto reprovado.
  const canAssumeRisk = ![
    APPROVED_STATUS_LABEL,
    RISK_ASSUMED_STATUS_LABEL,
  ].includes(privacyByDesign?.status)

  const handleReopenProject = async () => {
    try {
      await service.changeStatus({
        privacyByDesignId: privacyByDesign?.id,
        status: PENDING_STATUS_LABEL,
      })

      snackbar.open({ message: 'Projeto reaberto.', variant: 'success' })
      onReopen()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao reabrir projeto.',
        variant: 'error',
      })
    } finally {
      setOpenReopenDialog(false)
    }
  }

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={() => setOpenReopenDialog(true)}
      >
        Reabrir Projeto
      </Button>
      {canAssumeRisk && (
        <Button
          variant="outlined"
          color="primary"
          onClick={() => setOpenRiskAssumedDialog(true)}
        >
          Assumir Risco
        </Button>
      )}
      <ConfirmationDialog
        open={openReopenDialog}
        setOpen={setOpenReopenDialog}
        actionAcceptButton={handleReopenProject}
        text={CONFIRMATION_CHANGE_STATUS_TEXTS?.[REOPEN_ACTION_BUTTON_STATUS]}
        textButton="Confirmar"
      />
      <RiskAssumedDialog
        open={openRiskAssumedDialog}
        setOpen={setOpenRiskAssumedDialog}
        privacyByDesignId={privacyByDesign?.id}
        service={service}
        refresh={refresh}
      />
    </>
  )
}

export default PrivacyByDesignReviewActions
